import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import {
  shortData,
} from '../../helpers';
import CustomTable from '../../components/CustomTable/CustomTable';
import { RowAction, RowActions } from '../../components/RowActions/RowActions';

const columns = [
  {
    id: 'Id', label: 'Id',
  },
  {
    id: 'name', label: 'Name',
  },
  {
    id: 'mobile', label: 'Mobile',
  },
  {
    id: 'email',
    label: 'Email',
  },
  {
    id: 'product',
    label: 'Product',
  },
  {
    id: 'role',
    label: 'Role',
  },
  {
    id: 'subscriberName',
    label: 'Subscriber Name',
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const useStyles = () => ({
  tablewo: {
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  mainContainer: {
    // The page container (components/PageContainer) owns padding and width.
    width: '100%',
    minWidth: 0,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    margin: 20,
  },
  buttonLink: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 10,
  },
});

class table extends Component {
  render() {
    const {
      classes, handleShowEditForm, handleDeleteData, data,
      handleChangePage, handleChangeRowsPerPage, handleShowAddForm, tableName, search,
    } = this.props;

    return (
      <>
        <div className={classes.mainContainer}>

          <CustomTable
            icons={[{ icon: AddCircleOutlineRoundedIcon, name: 'Add User' }]}
            tableName={tableName}
            search={search}
            onIconClick={(key) => {
              handleShowAddForm(key);
            }}
            tableHead={columns}
            itemComponent={data.length > 0 ? data.map((element, index) => (
              <TableRow
                className={classes.tablewo}
                tabIndex={-1}
                key={element.id}
              >
                <TableCell>
                  {index + 1}
                </TableCell>
                <TableCell>
                  {shortData(`${element.firstName} ${element.lastName}` || '')}
                </TableCell>
                <TableCell>
                  {shortData(element.alternateNumber || '' || '')}
                </TableCell>
                <TableCell>
                  {shortData(element.email || '')}
                </TableCell>
                <TableCell>
                  {shortData(element?.UserProduct?.productName || '')}
                </TableCell>
                <TableCell>
                  {shortData(element?.UserRole?.role || '')}
                </TableCell>
                <TableCell>
                  {shortData(element?.Subscribers?.subscriberName || '')}
                </TableCell>
                <TableCell>
                  <RowActions>
                    <RowAction
                      kind='edit'
                      onClick={(key) => { handleShowEditForm(key, element); }}
                    />
                    <RowAction
                      kind='delete'
                      onClick={(key) => { handleDeleteData(key, element.id); }}
                    />
                  </RowActions>
                </TableCell>
              </TableRow>
            )) : null}
            count={1}
            rowsPerPage={0}
            page={1}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      </>
    );
  }
}

export default withStyles(useStyles)(table);
